<template>
  <div class="iv-m-t-24 iv-news-center-parent" style="width: 100%;height: 340px;">
    <Tab :navList="tabs">
      <span @click="toMorePage" class="iv-fs-14 iv-fc-25 iv-pointer" slot="extra">更多 ></span>
    </Tab>
    <ul class="iv-news-center iv-p-b-8 iv-p-t-12" v-if="list.length > 0">
      <li class="iv-news-center-li iv-m-t-16" v-for="(item, index) in list" :key="index" @click="todetail(item.infoId)">
        <p class="news-item__wrapper iv-fs-16 iv-fc-65 iv-m-t-8">
          <span class="iv-fs-16 iv-fc-85 iv-news-center-main">
            <span class="iv-m-r-8 iv-fc-45">[{{item.publishOrgName}}]</span><span class="iv-hover-color" :title="item.title">{{item.title}}</span>
          </span>
          <span class="iv-fs-14 iv-fc-45 iv-news-center-time">{{timeFormat(item.publishDate)}}</span>
        </p>
      </li>
    </ul>
    <NoData v-if="list.length <= 0"></NoData>
  </div>
</template>

<script>
import { timeFormat } from '@/utils'
import Tab from '@/components/tab'
import newsConfig from './news'
import courseConfig from './course'
import NoData from '@/components/no-data'
import Iconfont from '@/components/iconfont' 

export default {
  name: 'newsCenter',
  data () {
    return {
      list: []
    }
  },
  created () {
    this.map = {
      1: '党建',
      2: '工会',
      3: '青团',
      4: '文化',
      5: 'CCO'  
    }
    // this.list = newsConfig
    this.initTabs()
    this.getNewsList()
  },
  methods: {
    timeFormat,
    getNewsList() {
      this.$ajax({
        url: 'api-qixuan/infoPublish/info/public/mixInfo/list',
        method: 'get',
        data: {
          code: 'boe_home',
          rowNum: 6
        }
      }).then(({data}) => {
        this.list = data.data['boe_home'].map(val => ({
          ...val,
          title: val.title.replaceAll('%26', '&')
        }))
      })
    },
    //tab签点击事件
    tabClick (name) {
      if (name === 'xinwen') {
        this.list = newsConfig
      } else {
        this.list = courseConfig
      }
    },
    //点击更多
    toMorePage () {
      const { href } = this.$router.resolve({
        name: 'homePage'
      })
      window.open(href, '_blank')
    },
    todetail (id) {
      const { href } = this.$router.resolve({
        name: 'newsDetail',
        query: {
          infoId: id
        }
      })
      window.open(href, '_blank')
    },
    initTabs () {
      const arr = [{
        title: 'BOE家事',
        icon: 'xinwen'
      }]
      // , {
      //   title: '课程推荐',
      //   icon: 'kecheng'
      // }
      this.tabs = arr.map(item => ({
        label: (h) => {
          return h('div', [
            h(Iconfont, {
              props: {
                type: item.icon
              },
              style: 'margin-right: 10px'
            }),
            h('span', item.title)
          ])  
        },
        name: item.icon
      }))
    }
  },
  components: {
    Tab,
    NoData
  }
}
</script>

<style lang="scss" scoped>
.iv-news-center-parent {
  background: #fff;
  border-radius: 16px;
  padding: 0 20px 20px 20px;
}
.iv-news-center {
  .iv-news-center-li {
    position: relative;
    height: 24px;
    cursor: pointer;
    .iv-news-center-main {
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      display: inline-block;
      // width: 660px;
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
    }
    .iv-news-center-time {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-50%);
    }
  }
}
</style>
